<template>
  <div>
    <div class="topbanner">
      <div class="EC_width display_column_between height_100">
        <div></div>
        <div class="text_right">
          <span class="signBlock">
            <img src="/image/qkxy/fangzi.png"
                 class="marginTop40">
            <p class="signTitle marginTop20">入驻机构</p>
            <span class="signLine"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="positionBtn EC_width">
      <swiper :options="swiperOption"
              ref="mySwiper">
        <swiper-slide v-for="(item,index) in apiData.swiperbanner"
                      :key="index">
          <a href="javascript:;"
             class="mediaImg">
            <span class="inSign"><img src="/image/qkxy/injigou.png"
                   alt="">进入机构主页</span>
            <img :src="item.img"
                 alt=""
                 style="width: 100%;height: 100%">
          </a>
        </swiper-slide>
      </swiper>

      <div class="prevbutton2">&lt;</div>
      <div class="nextbutton2">&gt;</div>
    </div>
    <div class="EC_width">
      <div class="border_bottom_18  marginTop40 marginBottom20">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          线上参观
        </div>
      </div>
      <div class="display_between">
        <div>
          <a href="javascript:;"
             class="gl_pad_btn marginRight20">复亘大学附属中山医院项目</a>
          <a href="javascript:;"
             class="gl_pad_btn marginRight20">复亘大学附属中山医院项目</a>
          <a href="javascript:;"
             class="gl_pad_btn marginRight20">复亘大学附属中山医院项目</a>
        </div>
        <div>
          <span style="cursor: pointer;">更多</span>
        </div>
      </div>
      <div class="display_between marginTop20"
           v-for="(item,index) in onlineData"
           :key="index">
        <div class="pub_square"
             v-for="(itemn,indexn) in item"
             :key="indexn">
          <div class="pubs_img">
            <img :src="itemn.img">
          </div>
          <div class="pubs_body">
            <div class="pubs_title">
              {{itemn.title}}
            </div>
            <div class="pubs_label display_between">
              <div>
                <span v-for="(itemx,indexx) in itemn.sign"
                      :key="indexx">{{itemx}}</span>
              </div>
              <div class="pubs_cancel">
                取消收藏
              </div>
            </div>
            <div class="display_between">
              <div class="pubs_tip">
                <span class="redColor">{{itemn.price}}</span>
              </div>
              <div class="pubs_rentou">
                <img src="/image/geren/ren.png">{{itemn.num}}人
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gl_title_vertical_line gl_title_v_line_active fontBold marginTop40 marginBottom20">
        发现入驻机构
      </div>
      <div class="display_flex"
           style="padding-bottom: 40px">
        <div class="flex1 map">

        </div>
        <div class="rightSelect">
          <el-select v-model="valueCountry"
                     placeholder="请选择"
                     style="width: 100%;margin-bottom: 20px">
            <el-option v-for="item in optionsCourse"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="valueProvice"
                     placeholder="请选择"
                     style="width: 100%;margin-bottom: 20px">
            <el-option v-for="item in optionsCourse"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <div class="locList">
            <p class="listitem"
               v-for="(item,index) in apiData.list"
               :key="index">{{item.title}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="grayBlock">
      <div class="EC_width">
        <div class="border_bottom_18  marginTop40 marginBottom20 display_between">
          <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
            我的机构课程
          </div>
          <div>
            <el-select v-model="valueCourse"
                       size="small"
                       placeholder="请选择">
              <el-option v-for="item in optionsCourse"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="display_between">
          <div class="gl_title_vertical_line gl_title_v_line_active"
               style="border-left-width: 2px;">
            <span style="color: #0B8485;"
                  class="fontBold fontsize14">{{apiData.myCourse.title}}</span><br>
            <span class="fontBold fontsize14">{{apiData.myCourse.project}}</span> /
            <span class="fontsize14">{{apiData.myCourse.date}}</span>
          </div>
          <div>
            <a href="javascript:;"
               class="gl_pad_btn gl_pad_btn_active marginRight10"
               @click="showmodalModify=true">学分信息补充（已提交）</a>
            <a href="javascript:;"
               class="gl_pad_btn gl_pad_btn_active marginRight10"
               style="background: #B70009;"
               @click="showmodalSearch=true">学分查询</a>
            <span class="marginRight10">更多</span>
          </div>
        </div>
        <customModal :showmodal.sync="showmodalSearch">
          <div class="modalTitle"><img src="/image/jigou/jifen.png"
                 class="imgvertical-4 marginRight10"
                 alt=""><span>学分查询</span></div>
          <div class="text_center"
               style="line-height: 30px;">
            学分查询请在培训截止日期后，7个工作日内登录icme网站 <br>
            （http://www.icme.com）进行查询。
          </div>
        </customModal>
        <customModal :showmodal.sync="showmodalModify"
                     width="600px">
          <div class="modalTitle"><span>学籍信息查看</span></div>
          <div style="padding: 0 60px">
            <el-form :label-position="labelPosition"
                     label-width="80px"
                     size="small"
                     :model="formLabelAlign">
              <el-form-item label="姓名">
                <el-input v-model="formLabelAlign.name"></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input v-model="formLabelAlign.IDCard"></el-input>
              </el-form-item>
              <el-form-item label="工作单位">
                <el-input v-model="formLabelAlign.company"></el-input>
              </el-form-item>
              <el-form-item label="职称">
                <el-select v-model="formLabelAlign.profession"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in professionOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学历">
                <el-select v-model="formLabelAlign.education"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in professionOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="科室">
                <el-select v-model="formLabelAlign.department"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in professionOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地区">
                <el-select v-model="formLabelAlign.region"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in professionOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="text_center">
              <a href="javascript:;"
                 class="gl_pad_btn marginRight10">提交</a>
              <a href="javascript:;"
                 class="gl_pad_btn">取消</a>
            </div>
          </div>
        </customModal>
        <div class="display_between marginTop20"
             v-for="(item,index) in myCourselist"
             :key="index">
          <div class="pub_square"
               v-for="(itemn,indexn) in item"
               :key="indexn">
            <div class="pubs_img">
              <img :src="itemn.img">
            </div>
            <div class="pubs_body">
              <div class="pubs_title">
                {{itemn.title}}
              </div>
              <div class="pubs_progess">
                <div class="pubs_progess_active"
                     :style="{width:itemn.progress}">

                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span>已学</span>
                  <span class="normalColor">{{itemn.progress}}</span>
                </div>
                <div class="pubs_date">
                  {{itemn.date}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash"
export default {
  name: "mechanismHome",
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
  },
  data () {
    return {
      showmodalSearch: false,
      showmodalModify: false,
      labelPosition: 'right',
      apiData: "",
      onlineData: [],
      myCourselist: [],
      formLabelAlign: {
        name: '',
        IDCard: '',
        company: '',
        profession: "",
        education: "",
        department: "",
        region: ""
      },
      professionOptions: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      valueCountry: "",
      valueCourse: "",
      valueProvice: "",
      optionsCourse: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      swiperOption: {
        loop: true, //开启循环
        loopedSlides: 5, //在loop模式下使用slidesPerview:'auto',还需使用该参数设置所要用到的loop个数。
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量(carousel模式)。另外，支持'auto'值，会根据容器container的宽度调整slides数目。
        effect: 'coverflow', //可以实现3D效果的轮播,
        pagination: '.swiper-pagination', //分页器
        centeredSlides: true, //设定为true时，active slide会居中，而不是默认状态下的居左。
        coverflowEffect: {
          rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
          stretch: 100, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
          depth: 150, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
          modifier: 1, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
          slideShadows: false, //开启slide阴影。默认 true。
        },
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
        on: {
          slideChange: () => {
            // alert('改变了，activeIndex为'+this.swiper.activeIndex);
          },
        },
      }
    }
  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.mechanismHome;
        var useOnline = data.mechanismHome.online;
        var usemyCourselist = data.mechanismHome.myCourse.list;
        that.onlineData = lodash.chunk(useOnline, 4);
        this.myCourselist = lodash.chunk(usemyCourselist, 4);
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style scoped>
.modalTitle {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 50px;
    text-align: center;
}
.blocknext,
.blockpre {
    display: inline-block;
    width: 16px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    box-sizing: border-box;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 10px;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.blocknext {
    right: 0;
}
.blockpre {
    left: 0;
}
/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 40%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.nextbutton2,
.prevbutton2 {
    top: 40%;
}
.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}
.topbanner {
    height: 400px;
    width: 100%;
    background: url(/image/qkxy/banner.png) center no-repeat;
}
.signBlock {
    width: 284px;
    height: 251px;
    background: #0b8586;
    opacity: 0.95;
    border-radius: 10px 10px 0px 0px;
    display: inline-block;
    text-align: center;
}
.signTitle {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
}
.signLine {
    display: inline-block;
    margin-top: 30px;
    width: 43px;
    height: 1px;
    background: #ffffff;
}
.grayBlock {
    background: #f6f7fb;
    padding: 40px 0;
}
/* 轮播宽度 */
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1300px;
}

.mediaImg {
    position: relative;
    display: inline-block;
    width: 496px;
    height: 280px;
    background: #fff;
    box-shadow: 10px 17px 20px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
}

.gl_pad_btn:hover {
    background: #0b8485;
    color: #fff;
}

.rightSelect {
    width: 294px;
    margin-left: 70px;
}

.locList {
    width: 294px;
    height: 428px;
    background: #f6f7fb;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 28px 41px 26px 28px;
}

.listitem {
    text-align: justify;
    margin-bottom: 20px;
    cursor: pointer;
}

.listitem:hover {
    color: #007380;
    text-decoration: underline;
}

.locList::-webkit-scrollbar {
    width: 5px;
    background: #eeeeee;
}

/* 滚动槽 */
.locList::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.locList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}

.locList::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}
.inSign {
    width: 130px;
    height: 35px;
    background: #007380;
    border-radius: 5px 0px 0px 0px;
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 35px;
    color: #fff;
}
.inSign img {
    vertical-align: -5px;
    margin-right: 5px;
}
</style>
